import { ScrollableRightMenu } from "../../components/ScrollableRightMenu";
import { VerticalStepper } from "./VerticalStepper";

export const StepperRightMenu = ({
  heading,
  buttonProps,

  activeStepIndex = 0,
  onStepClick,
  steps,
}) => {
  return (
    <ScrollableRightMenu heading={heading} buttonProps={buttonProps}>
      <VerticalStepper
        activeStepIndex={activeStepIndex}
        // onStepClick={onStepClick}
        steps={steps}
      />
    </ScrollableRightMenu>
  );
};
